module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/bezier-curve-604c9f5a381f335c2515023d4ad6aab2.svg";